var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page add-repository"},[_c('div',{staticClass:"header"},[_c('h1',[_vm._v("Submit your repository for indexing")])])])
}]

export { render, staticRenderFns }